/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Team_EmptyInputs */

const en_case_detail_team_empty = /** @type {(inputs: Case_Detail_Team_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No team members assigned yet.`)
};

const pt_br2_case_detail_team_empty = /** @type {(inputs: Case_Detail_Team_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum membro atribuído ainda.`)
};

/**
* | output |
* | --- |
* | "No team members assigned yet." |
*
* @param {Case_Detail_Team_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_team_empty = /** @type {((inputs?: Case_Detail_Team_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Team_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_team_empty(inputs)
	return pt_br2_case_detail_team_empty(inputs)
});